module.exports = __webpack_public_path__ + "static/media/credit-card(gray).3fd9a429.svg";